import React, { useState, useEffect } from "react";
import {
  fetchRequestRepositorysById,
  requestRepositoryUpdate,
} from "../../../redux/slices/RequestRepositorySlice";
import { useAppDispatch, useAppSelector } from "../../../redux/store/store";
import { Link, useParams, useNavigate } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";
import { refreshToken2 } from '../../../refreshToken2';
import { useMsal } from '@azure/msal-react';
import "./AdminRequestRepository.css";
import Swal from "sweetalert2";
import {
  isHttpCodeSuccess,
  handleSwalMessage,
} from "../../../Helpers/Http.commons";

interface BusinessInformation {
  businessName: string;
  businessCostCenter: string;
  businessResponsible: string;
}

interface RepositoryInformation {
  name: string;
  description: string;
}

interface IRequestsRepositories {
  id: string;
  businessInformation: BusinessInformation;
  repositoryInformation: RepositoryInformation;
  status: string;
  organization: string;
  requestedBy: string;
  owner: string;
}

const ListAdminRepositoryRequest = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const requestId = String(id);
  const navigate = useNavigate();
  const { instance } = useMsal();

  

  useEffect(() => {
    setLoading(true);
    loadContent();
    setLoading(false);
  }, [requestId]);

  const loadContent = async () => {
    await refreshToken2(instance);
    console.log("refreshToken2 finished");
    if(requestId) await dispatch(fetchRequestRepositorysById(requestId));
    console.log("fetch fetchRequestRepositorysById finished");
  };
  
  const handleDocumentRequest = (requestId: string, status: string) => {
    dispatch(
      requestRepositoryUpdate({
        id: requestId,
        data: { status },
      })
    ).then((responseData) => {
      if (requestRepositoryUpdate.fulfilled.match(responseData)) {
        const { statusCode, response, error } = responseData.payload;
        const statusmessage = status == "inprocess" ? "Aprobada" : "Rechazada";
        const message = `La solicitud fue correctamente ${statusmessage}`
        const swalData: any = handleSwalMessage(responseData.payload, message);
        Swal.fire(swalData);

        if (isHttpCodeSuccess(statusCode)) {
          console.log(
            "============ REDIRECT LOG: [AdminRequestRepository] - Navigate to /my-repositories"
          );
          navigate("/my-repositories");
        }
      } else if (requestRepositoryUpdate.rejected.match(responseData)) {
        Swal.fire({
          icon: "error",
          title: "Error de Conexión",
          text: "Revise su conexión a internet y vuelva a intentar",
        });
      }
      setLoading(false);
    });
  };

  const result: IRequestsRepositories[] = useAppSelector(
    (state) => state.RequestRepositorySlice.result
  );

  const resultado = JSON.stringify(result);
  console.log(`Valor de resultado: ${resultado}!`);

  const obj = JSON.parse(resultado);
  const { id: ids, status, organization, requestedBy, owner } = obj;
  const { businessInformation, repositoryInformation } = obj || {};
  const { businessName, businessCostCenter, businessResponsible } =
    businessInformation || {};
  const { name: repositoryName, description: repositoryDescription } =
    repositoryInformation || {};

  return loading ? (
    <Spinner />
  ) : (
    <div className="access-request-card-wrapper row equal-cols">
      <div className="col-12 col-md-6 col-lg-4">
        <div className="pds-card pds-productCard">
          <div
            className="pds-card-section pds-card-bg-primary-blue-2"
            tabIndex={0}
          >
            <h3 className="pds-card-title pds-typography-truncate">
              Solicitud de Repositorio
            </h3>
            <p className="pds-typography-body-14">
              (*)Para continuar con la solicitud favor seleccionar aprobar o
              rechazar
            </p>
          </div>
          <div className="pds-card-section">
            <dl className="pds-gridTable" tabIndex={0}>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Descripcion:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">
                    {repositoryDescription}
                  </span>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Repositorio:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">{repositoryName}</span>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Organizacion:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">{organization}</span>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Centro de costos:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">
                    {businessCostCenter}
                  </span>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Nombre del Negocio:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">{businessName}</span>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Responsable del Negocio:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">
                    {businessResponsible}
                  </span>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Email solicitante:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">{requestedBy}</span>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Dueño:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">{owner}</span>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  Estado:
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-bold">{status}</span>
                </dd>
              </div>
            </dl>
          </div>
          <div className="pds-card-section pds-card-top-divider divider-button">
            <div className="action-section">
              {status === "rejected" || status === "finished" ? (
                <Link to="/">
                  <button className="pds-button pds-button-primary button-access-request-back">
                    <i data-feather="arrow-left" aria-hidden="true"></i> Volver
                  </button>
                </Link>
              ) : (
                <div>
                  <button
                    className="pds-button pds-button-primary button-access-request-approve"
                    disabled={
                      status === "rejected" ||
                      status === "finished" ||
                      status === "inprocess" ||
                      loading
                    }
                    onClick={async () => {
                      setButtonLoading(true);
                      handleDocumentRequest(requestId, "inprocess");
                      setButtonLoading(false);
                    }}
                  >
                    <i data-feather="check-circle" aria-hidden="true"></i>{" "}
                    {loading ? <Spinner /> : "Aprobar"}
                  </button>

                  <button
                    className="pds-button pds-button-primary button-access-request-rejected"
                    disabled={
                      status === "rejected" ||
                      status === "finished" ||
                      status === "inprocess" ||
                      loading
                    }
                    onClick={async () => {
                      setButtonLoading(true);
                      handleDocumentRequest(requestId, "rejected");
                      setButtonLoading(false);
                    }}
                  >
                    <i data-feather="trash-2" aria-hidden="true"></i>{" "}
                    {buttonLoading ? <Spinner /> : "Rechazar"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListAdminRepositoryRequest;
